var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-state grid gap-1 h-full items-end text-center px-3"},[_vm._t("icon"),_vm._t("title"),_c('div',{staticClass:"self-start flex flex-col items-center"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }